import {
  bikeMap,
  BikeTour,
  GastronomyTour,
  // SelfGuidedTour,
  TourDetail,
  WineTaste,
  WineTasteDetail,
} from "../assets/photos";
import { BikeSvg, GrapesSvg, WineGlassSvg } from "../assets/svg";

export const navBarItems = [
  {
    key: 1,
    name: "Home",
    path: "/",
  },
  {
    key: 2,
    name: "Explore Tours",
    path: "/tours-experiences",
  },
  {
    key: 3,
    name: "About Us",
    path: "/about-us",
  },
  {
    key: 4,
    name: "Contacts",
    path: "/contacts",
  },
];

export const phone = "+355 69 44 59 929";

export const wpPhone = "355694459929";

export const email = "shkodertourguide@gmail.com";

export const location = "Shkoder, Albania";

export const hours = "Monday - Sunday: 8:00 AM - 8:00 PM";

export const packages = [
  // {
  //   id: 1,
  //   title: [
  //     {
  //       id: 0,
  //       label: "Self Guided Shkoder Guide",
  //     },
  //     {
  //       id: 1,
  //       label: "Udhëzues i Shkodrës për Vetëudhëtim",
  //     },
  //   ],
  //   description: [
  //     {
  //       id: 0,
  //       label:
  //         "Explore Shkoder at your own pace with our digital guide. All the mustsee spoots, local tips and hidden gems in one guide",
  //     },
  //     {
  //       id: 1,
  //       label:
  //         "Eksploroni Shkodrën me ritmin tuaj me udhëzuesin tonë digjital. Të gjitha vendet që duhet të shihni, këshillat lokale dhe thesaret e fshehura në një udhëzues",
  //     },
  //   ],
  //   subCategory: [
  //     {
  //       id: 0,
  //       label: "OUTDOOR & ADVENTURE",
  //     },
  //     {
  //       id: 1,
  //       label: "OUTDOOR & ADVENTURE",
  //     },
  //   ],
  //   price: 5,
  //   img: SelfGuidedTour,
  //   svg: <BookGuideSvg width={36} height={36} />,
  // },
  {
    id: 2,
    title: [
      {
        id: 0,
        label: "Bike Tour City Guide",
      },
      {
        id: 1,
        label: "Udhëzues i Shkodrës për Vetëudhëtim",
      },
    ],
    description: [
      {
        id: 0,
        label:
          "Discover the city on two wheels! A guided bike tour through the most beautifull streets, landmarks and local stories.",
      },
      {
        id: 1,
        label:
          "Zbulo qytetin me dy rrote! Një tur me bislëp të udhëzuar në rrugët më të gjalla, landmarket dhe historitë lokale.",
      },
    ],
    img: BikeTour,
    price: 10,
    svg: <BikeSvg width={36} height={36} />,
    subCategory: [
      {
        id: 0,
        label: "OUTDOOR & ADVENTURE",
      },
      {
        id: 1,
        label: "OUTDOOR & ADVENTURE",
      },
    ],
    duration: "45 - 55 Minutes",
    itinerary: {
      img: bikeMap,
      highlights: [
        {
          items: ["Discover the rich history of Shkodër with a local guide."],
        },
        {
          items: ["Zbulo historinë e pasur të Shkodrës me një guidë lokale."],
        },
      ],
      whatToBring: [
        {
          items: ["Sunglasses", "Water"],
        },
        {
          items: ["Syze dielli", "Ujë"],
        },
      ],
      included: [
        {
          items: ["Free live tour guide", "Free bicycles"],
        },
        {
          items: ["Guidë turistike live falas", "Biçikleta falas"],
        },
      ],
      timeline: [
        {
          language: "english",
          items: [
            {
              time: "",
              title: "Starting Location",
              description: ["Cathedral of Shkoder"],
            },
            {
              time: "5 - 10 min",
              title: "Cathedral of Shkoder",
              description: ["Photo stop, guided tour"],
            },
            {
              time: "5 - 10 min",
              title: "Mother Tereza Square",
              description: ["Photo stop, guided tour"],
            },
            {
              time: "5 - 10 min",
              title: "Cinar Tree + Museum House Oso Kuka",
              description: ["Photo stop, guided tour"],
            },
            {
              time: "",
              title: "Cycle Through the Zdrale Bazar",
              description: [],
            },
            {
              time: "5 - 10 min",
              title: "Town Hall of Shkoder",
              description: ["Photo stop, guided tour"],
            },
            {
              time: "",
              title: "Arrive Back At Cathedral of Shkoder",
              description: [],
            },
          ],
        },

        {
          language: "albanian",
          items: [
            {
              time: "",
              title: "Vendndodhja e Nisjes",
              description: ["Katedralja e Shkodrës"],
            },
            {
              time: "5 - 10 min",
              title: "Katedralja e Shkodrës",
              description: ["Ndalesë për foto, tur guidues"],
            },
            {
              time: "5 - 10 min",
              title: "Sheshi Nënë Tereza",
              description: ["Ndalesë për foto, tur guidues"],
            },
            {
              time: "5 - 10 min",
              title: "Rrapi i Çinarit + Shtëpia Muze Oso Kuka",
              description: ["Ndalesë për foto, tur guidues"],
            },
            {
              time: "",
              title: "Xhiro me biçikletë në Pazarin e Zdrales",
              description: [],
            },
            {
              time: "5 - 10 min",
              title: "Bashkia e Shkodrës",
              description: ["Ndalesë për foto, tur guidues"],
            },
            {
              time: "",
              title: "Kthimi tek Katedralja e Shkodrës",
              description: [],
            },
          ],
        },
      ],
    },
  },
  {
    id: 3,
    title: [
      {
        id: 0,
        label: "Taste of Shkoder: Wine and Gastronomy Experience",
      },
      {
        id: 1,
        label: "Gjak i Shkodrës: Eksperience e Vinës dhe Gastro-nomisë",
      },
    ],
    description: [
      {
        id: 0,
        label:
          "A delicious journey through the flavors of Shkoder! Traditional dishes paired with selected local wines.",
      },
      {
        id: 1,
        label:
          "Një udhëtim i shijshëm përmes shijeve të Shkodrës! Gatime tradicionale të shoqëruara me verëra lokale të përzgjedhura.",
      },
    ],
    img: GastronomyTour,
    price: 40,
    svg: <WineGlassSvg width={36} height={36} />,
    subCategory: [
      {
        id: 0,
        label: "OUTDOOR & ADVENTURE",
      },
      {
        id: 1,
        label: "OUTDOOR & ADVENTURE",
      },
    ],
    duration: "6:00 h",
    itinerary: {
      img: TourDetail,
      tips: [
        {
          items: [
            "Respect the winery environment",
            "Follow the guide’s instructions",
            "Please inform the guide about any food allergies",
          ],
        },
        {
          items: [
            "Respektoni ambientin e kantinës",
            "Ndiqni udhëzimet e guidës",
            "Ju lutem njoftoni guidën për çdo alergji ushqimore",
          ],
        },
      ],
      notIncluded: [
        {
          items: ["Extra food or drinks beyond the set menu"],
        },
        {
          items: ["Ushqim ose pije shtesë jashtë menusë së përcaktuar"],
        },
      ],
      highlights: [
        {
          items: [
            "Authentic winery visit in the Shkodër region",
            "Wine tasting experience with local varieties",
            "Traditional Albanian lunch with organic products",
            "Relaxed atmosphere in a scenic vineyard setting",
          ],
        },
        {
          items: [
            "Vizitë autentike në kantinë në rajonin e Shkodrës",
            "Përvojë degustimi vere me varietete lokale",
            "Drekë tradicionale shqiptare me produkte organike",
            "Atmosferë e qetë në një vresht piktoresk",
          ],
        },
      ],
      whatToBring: [
        {
          items: ["Cameras and smartphones for photos"],
        },
        {
          items: ["Kamera dhe telefona për foto"],
        },
      ],
      included: [
        {
          items: [
            "Free tour guide during the winery visit",
            "Free round-trip transportation",
            "Wine tasting",
            "Traditional lunch",
          ],
        },
        {
          items: [
            "Guidë falas gjatë vizitës në kantinë",
            "Transport vajtje-ardhje falas",
            "Degustim vere",
            "Drekë tradicionale",
          ],
        },
      ],
      timeline: [
        {
          language: "english",
          items: [
            {
              time: "11:00",
              title: "Departure from Shkodër",
              description: [
                "Group meeting at Hotel Rozafa",
                "Guide introduction + area overview",
              ],
            },

            {
              time: "11:30",
              title: "Arrival at the Winery",
              description: [
                "Free guided tour through the vineyards",
                "Introduction to local grape variety",
                "Explanation of the winemaking process",
                "Wine tasting",
              ],
            },

            {
              time: "13:00",
              title: "Traditional Lunch",
              description: [
                "Enjoy a carefully prepared meal made with fresh, local ingredients, paired with the winery’s own wine.",
                "Traditional Menu:",
                "Beef",
                "Yogurt and egg pie (Byrek)",
                "Village salad",
                "Pickled vegetables (cucumbers, peppers, eggplant, cabbage)",
                "White cheese (cow or sheep)",
                "Albanian fried dish with cottage cheese",
                "Homemade bread",
                "For any allergies or dietary preferences, please inform us before the meal is prepared.",
              ],
            },

            {
              time: "15:00",
              title: "Free Time for Photos and Walking",
              description: [
                "Relax, explore the vineyard, and take beautiful photos of the surrounding landscape.",
              ],
            },

            {
              time: "16:00",
              title: "Departure for Return",
              description: ["Return journey to Shkoder"],
            },
          ],
        },

        {
          language: "albanian",
          items: [
            {
              time: "11:00",
              title: "Nisja nga Shkodra",
              description: [
                "Takimi i grupit tek Hotel Rozafa",
                "Prezantimi i guidës + përshkrimi i zonës",
              ],
            },

            {
              time: "11:30",
              title: "Mbërritja në Kantinë",
              description: [
                "Tur guidues falas nëpër vreshta",
                "Prezantim me varietetet lokale të rrushit",
                "Shpjegimi i procesit të prodhimit të verës",
                "Degustim vere",
              ],
            },

            {
              time: "13:00",
              title: "Drekë Tradicionale",
              description: [
                "Shijoni një vakt të përgatitur me kujdes me produkte të freskëta lokale, i shoqëruar me verën e kantinës.",
                "Menu Tradicionale:",
                "Mish viçi",
                "Byrek me kos dhe vezë",
                "Sallatë fshati",
                "Turshi (kastravecë, speca, patëllxhan, lakër)",
                "Djathë i bardhë (lope ose dele)",
                "Pjatë tradicionale shqiptare e skuqur me gjizë",
                "Bukë shtëpie",
                "Për çdo alergji ose preferencë ushqimore, ju lutem na njoftoni përpara përgatitjes së vaktit.",
              ],
            },

            {
              time: "15:00",
              title: "Kohë e lirë për foto dhe shëtitje",
              description: [
                "Relaksohuni, eksploroni vreshtin dhe bëni foto të bukura të peizazhit përreth.",
              ],
            },

            {
              time: "16:00",
              title: "Nisja për kthim",
              description: ["Kthimi drejt Shkodrës"],
            },
          ],
        },
      ],
    },
  },
  {
    id: 4,
    title: [
      {
        id: 0,
        label: "Wine Tasting Experience",
      },
      {
        id: 1,
        label: "Udhëzues i Shkodrës",
      },
    ],
    description: [
      {
        id: 0,
        label:
          "Taste the best of local wines in a cozy setting and learn about the traditions behind each glass.",
      },
      {
        id: 1,
        label:
          "Shijoni më të mirat e verërave lokale në një ambient të ngrohtë dhe mësoni rreth traditave pas çdo gote.",
      },
    ],
    img: WineTaste,
    price: 20,
    svg: <GrapesSvg width={36} height={36} />,
    subCategory: [
      {
        id: 0,
        label: "OUTDOOR & ADVENTURE",
      },
      {
        id: 1,
        label: "OUTDOOR & ADVENTURE",
      },
    ],
    duration: "2:30 h",
    itinerary: {
      img: WineTasteDetail,
      tips: [
        {
          items: [
            "Respect the winery environment.",
            "Follow the guide’s instructions.",
          ],
        },
        {
          items: [
            "Respektoni ambientin e kantinës.",
            "Ndiqni udhëzimet e guidës.",
          ],
        },
      ],
      highlights: [
        {
          items: [
            "Winery visit and wine tasting",
            "History and grape varieties of the region",
          ],
        },
        {
          items: [
            "Vizitë në kantinë dhe degustim vere",
            "Historia dhe varietetet e rrushit të rajonit",
          ],
        },
      ],
      whatToBring: [
        {
          items: ["Cameras and smartphones for photos"],
        },
        {
          items: ["Kamera dhe telefona për foto"],
        },
      ],
      included: [
        {
          items: [
            "Free tour guide during the winery visit",
            "Free round-trip transportation",
            "Wine tasting",
          ],
        },
        {
          items: [
            "Guidë falas gjatë vizitës në kantinë",
            "Transport vajtje-ardhje falas",
            "Degustim vere",
          ],
        },
      ],
      timeline: [
        {
          language: "english",
          items: [
            {
              time: "10:00",
              title: "Departure from Shkodër",
              description: [
                "Group meeting at Hotel Rozafa",
                "Guide introduction + area overview",
              ],
            },
            {
              time: "10:30",
              title: "Arrival at the Winery",
              description: [
                "Free guided tour through the vineyards",
                "Explanation of the winemaking process",
                "Wine tasting",
              ],
            },
            {
              time: "11:45",
              title: "Free Time for Photos and Walking",
              description: [
                "Enjoy the scenery and relax while exploring the winery surroundings and taking photos.",
              ],
            },
            {
              time: "12:00",
              title: "Departure for Return",
              description: [],
            },
            {
              time: "12:30",
              title: "Arrival in Shkodër",
              description: ["Drop-off again at Hotel Rozafa"],
            },
          ],
        },

        {
          language: "albanian",
          items: [
            {
              time: "10:00",
              title: "Nisja nga Shkodra",
              description: [
                "Takimi i grupit tek Hotel Rozafa",
                "Prezantimi i guidës + përshkrimi i zonës",
              ],
            },
            {
              time: "10:30",
              title: "Mbërritja në Kantinë",
              description: [
                "Tur guidues falas nëpër vreshta",
                "Shpjegimi i procesit të prodhimit të verës",
                "Degustim vere",
              ],
            },
            {
              time: "11:45",
              title: "Kohë e lirë për foto dhe shëtitje",
              description: [
                "Shijoni peizazhin dhe relaksohuni duke eksploruar ambientet e kantinës dhe duke bërë foto.",
              ],
            },
            {
              time: "12:00",
              title: "Nisja për kthim",
              description: [],
            },
            {
              time: "12:30",
              title: "Mbërritja në Shkodër",
              description: ["Zbritja përsëri tek Hotel Rozafa"],
            },
          ],
        },
      ],
    },
  },
];
